/*
 * File: index.tsx
 * Desc: 重写tab bar组件
 * File Created: 2019-10-28 16:04:19
 * Author: chenghao at <hao.cheng@karakal.com.cn>
 * ------
 * Copyright 2019 - present, karakal
 */
import React, { useState, useLayoutEffect, useRef } from 'react';
import { TabsProps } from 'antd/lib/tabs';
import classNames from 'classnames';
import { TabInkbar } from '..';

interface TabBarProps extends TabsProps {
    panels?: any;
    style?: React.CSSProperties;
    className?: string;
    /** 单个tab bar的样式 */
    barStyle?: React.CSSProperties;
    /** 单个tab bar的类名 */
    barClassName?: string;
    /** tab bar下划线的样式 */
    inkBarStyle?: React.CSSProperties;
    /** tab bar下划线的类名 */
    inkBarClassName?: string;
    onChange?: (key?: any) => void;
}

const prefix = 'rac_tab_bar';

const TabBar = (props: TabBarProps) => {
    const { panels } = props;
    const [activeKey, setActiveKey] = useState(props.activeKey);
    const [target, setTarget] = useState<HTMLElement | null>(null);
    /** 缓存所有的bar dom元素 */
    const barRef = useRef<any>({});

    function onBarClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>, key: string) {
        setTarget(event.target as HTMLDivElement);
        setActiveKey(key);
        props.onChange && props.onChange(key);
    }

    useLayoutEffect(() => {
        if (props.activeKey) {
            setTarget(barRef.current[props.activeKey]);
            setActiveKey(props.activeKey);
        }
    }, [props.activeKey]);

    return (
        <div style={{ position: 'relative', ...props.style }} className={props.className}>
            {panels &&
                panels.map(
                    (panel: any) =>
                        panel &&
                        panel.props && (
                            <div
                                ref={dom => (barRef.current[panel.key] = dom)}
                                // ref={(activeKey ? activeKey === panel.key : index === 0) ? barRef : null}
                                className={classNames(
                                    prefix,
                                    {
                                        [`${prefix}-active`]: activeKey === panel.key,
                                    },
                                    props.barClassName
                                )}
                                key={panel.key}
                                onClick={e => onBarClick(e, panel.key)}
                                style={{ ...props.barStyle, ...panel.style }}
                            >
                                {panel.props.tab}
                            </div>
                        )
                )}
            {target && (
                <TabInkbar
                    offsetLeft={target.offsetLeft}
                    targetWidth={target.offsetWidth}
                    className={props.inkBarClassName}
                    style={props.inkBarStyle}
                />
            )}
        </div>
    );
};

export default TabBar;
